module.exports = __webpack_public_path__ + "static/media/loader.aa0aaf92.svg";